import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

const ADMIN_DEFINITIONS_KEY = ['/admin/company-profile/section-definitions'];
const ADMIN_INSTRUCTIONS_KEY = ['/admin/company-profile/generation-instructions'];
const CLIENT_DEFINITIONS_KEY = ['/company-profile/section-definitions'];

const invalidateDefinitionQueries = (queryClient) => {
  queryClient.invalidateQueries({ queryKey: ADMIN_DEFINITIONS_KEY });
  queryClient.invalidateQueries({ queryKey: CLIENT_DEFINITIONS_KEY });
};

export const getAdminSectionDefinitions = ({ accessToken, params } = {}) =>
  queryOptions({
    queryKey: [...ADMIN_DEFINITIONS_KEY, params],
    queryFn: async () => {
      const res = await axiosGet('/admin/company-profile/section-definitions', { params }, accessToken);
      return res.data;
    },
  });

export const getAdminGenerationInstructions = ({ accessToken } = {}) =>
  queryOptions({
    queryKey: ADMIN_INSTRUCTIONS_KEY,
    queryFn: async () => {
      const res = await axiosGet('/admin/company-profile/generation-instructions', {}, accessToken);
      return res.data;
    },
  });

export const useUpdateGenerationInstructions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => axiosPut('/admin/company-profile/generation-instructions', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_INSTRUCTIONS_KEY });
    },
  });
};

export const useCreateSectionDefinition = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => axiosPost('/admin/company-profile/section-definitions', data),
    onSuccess: () => invalidateDefinitionQueries(queryClient),
  });
};

export const useUpdateSectionDefinition = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => axiosPut(`/admin/company-profile/section-definitions/${id}`, data),
    onSuccess: () => invalidateDefinitionQueries(queryClient),
  });
};

export const useReorderSectionDefinitions = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => axiosPut('/admin/company-profile/section-definitions/reorder', data),
    onSuccess: () => invalidateDefinitionQueries(queryClient),
  });
};

export const useDeleteSectionDefinition = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => axiosDelete(`/admin/company-profile/section-definitions/${id}`),
    onSuccess: () => invalidateDefinitionQueries(queryClient),
  });
};
